import React from 'react';

const MinusIcon = () => {
  return (
    <div style={{ minWidth: '16px' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g
          fill="none"
          fillRule="evenodd"
          stroke="#9000FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M7 14M0 7L14 7" transform="translate(1 1)" />
        </g>
      </svg>
    </div>
  );
};

export default MinusIcon;
